import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
// import { handleGetRequest } from "../../../services/GetTemplate";
// import { handlePostRequest } from "../../../services/PostTemplate";
// import { handlePutRequest } from "../../../services/PutTemplate";
import { useDispatch, useSelector } from "react-redux";
// import { SetEditCompanyAccountFlagAction, SetCompanyAccountFormDataToNullAction, GetCompanyAccountDetailsAction } from "../../../redux/actions/companyAction";
import * as Yup from "yup";

function AddEditCountryManagement({ companyId, editable }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [bankOptions, setbankOptions] = useState([]);
    const [branchOptions, setbranchOptions] = useState([]);

    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (!editable) {
    //         formik.resetForm();
    //     }
    // }, [editable]);

    const url = require("url");
    const urlObj = url.parse(document.location.href, true);
    const edit = urlObj?.query?.editable;

    // const editFlag__Store = useSelector((state) => state.companySlice?.companyAccountEditFlag);
    // const formData__Store = useSelector((state) => state.companySlice?.companyAccountFormData);

    // useEffect(() => {
    //     if (editFlag__Store) {
    //         fillCompanyAccountForm();
    //     }
    // }, [editFlag__Store, formData__Store]); // eslint-disable-line

    // useEffect(() => {
    //     handleGetRequest("/zbiz/lov/lovBank").then((res) => {
    //         setbankOptions(res?.data);
    //     });
    // }, []);

    // useEffect(() => {
    //     handleGetRequest("/zbiz/lov/lovBranch").then((res) => {
    //         setbranchOptions(res?.data);
    //     });
    // }, []);

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
    };
    // const getCompanyAccountDetail = async () => {
    //     await dispatch(GetCompanyAccountDetailsAction("zbiz/nonFin/getAccounts/" + companyId));
    // };

    // const fillCompanyAccountForm = () => {
    //     formik.setFieldValue("bankId", formData__Store?.bankId?.toString());
    //     formik.setFieldValue("bankName", formData__Store?.bankName?.toString());
    //     formik.setFieldValue("isPrincipal", formData__Store?.isPrincipal?.toString());
    // };

    const validationSchema = Yup.object().shape({
        countryCode: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
        countryName: Yup.string()
            .required("This field is required.")
            .matches(/^[A-Za-z0-9 ]+$/, "Special Character are not allowed")
            .max(20, "Maximum length 20 allowed"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            countryCode: "",
            countryName: "",
            isActive: false,
            isApproved: false,
        },

        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["bankId"] = data?.bankId?.id;
            data["branchId"] = data?.branchId?.id;

            // if (editFlag__Store) {
            //     data["accountId"] = formData__Store?.accountId;
            //     const res = await handlePutRequest(data, "zbiz/nonFin/updateCompanyAccounts");
            //     if (res.status === 400) {
            //         res?.data.forEach((element) => {
            //             formik.setFieldError(element?.field, element?.message);
            //         });
            //     } else {
            //         dispatch(SetEditCompanyAccountFlagAction(false));
            //         dispatch(SetCompanyAccountFormDataToNullAction());
            //     }
            // } else {
            //     data["companyId"] = companyId;
            //     const res = await handlePostRequest(data, "zbiz/nonFin/saveCompanyAccounts");
            //     if (res.status === 400) {
            //         res?.data.forEach((element) => {
            //             formik.setFieldError(element?.field, element?.message);
            //         });
            //     } else formik.resetForm();
            // }
            setloading(false);
            setloadingIcon("pi pi-save");
            // getCompanyAccountDetail();
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>{edit ? "Edit Country" : "Add Country"}</h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="bankId" className={classNames({ "p-error": isFormFieldValid("bankId") }, "Label__Text")}>
                                Country Code<span className="Label__Required">*</span>
                            </label>
                            <InputText id="bankId" placeholder="#xxxxxxxx" name="bankId" value={formik?.values?.bankId?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("bankId") }, "Input__Round")} />

                            {getFormErrorMessage("bankId")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="bankName" className={classNames({ "p-error": isFormFieldValid("bankName") }, "Label__Text")}>
                                Country Name<span className="Label__Required">*</span>
                            </label>
                            <InputText id="bankName" placeholder="#xxxxxxxx" name="bankName" value={formik?.values?.bankName?.toString()?.trim()} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("bankName") }, "Input__Round")} />

                            {getFormErrorMessage("bankName")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="transferType" className={classNames({ "p-error": isFormFieldValid("transferType") }, "Label__Text")}>
                                Is Active
                            </label>
                            <div className="field-checkbox">
                                <Checkbox inputId="transferType" name="transferType" value={formik.values.transferType} checked={formik.values.transferType} onChange={formik.handleChange} />
                            </div>
                            {getFormErrorMessage("transferType")}
                        </div>
                    </div>
                    {edit ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="isApproved" className={classNames({ "p-error": isFormFieldValid("isApproved") }, "Label__Text")}>
                                    Is Approved
                                </label>
                                <div className="field-checkbox">
                                    <Checkbox inputId="isApproved" name="isApproved" value={formik.values.isApproved} checked={formik.values.isApproved} onChange={formik.handleChange} />
                                </div>
                                {getFormErrorMessage("isApproved")}
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="Down__Btn">
                    <Button label="Cancel" onClick={(e) => handleCancel(e)} className="Btn__Transparent" />
                    <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={edit ? "Update" : "Save"} className="Btn__Dark" />
                    {edit ? (
                        <>
                            <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label="Approve" className="Btn__Dark" />
                        </>
                    ) : null}
                </div>
            </form>
        </div>
    );
}

export default AddEditCountryManagement;
